import Vue from 'vue';
import moment from 'moment';

export default new Vue({
  data() {
    return {
      periodType: null,
      periodValue: null,
      periodYear: null
    };
  },
  methods: {
    initPeriodState() {
      const { searchParams } = new URL(window.location.href);

      const periodType = searchParams.get('periodType') || 'month';
      const periodValue = searchParams.get('periodValue') || moment().get('month');
      const periodYear = searchParams.get('periodYear') || moment().get('years');

      this.periodType = periodType;
      this.periodValue = periodValue;
      this.periodYear = periodYear;
    }
  }
});
